<div
  [attr.role]="mode === TAB_MODE.ACCORDIAN ? 'region' : 'tabpanel'"
  [tabindex]="tab.disableBorderFocus ? -1 : 0"
  [attr.aria-labelledby]="tab.id ?? null"
  [attr.id]="tab.id ? 'section-' + tab.id : null"
  class="active"
  [cxFocus]="{ focusOnEscape: !tab.disableBorderFocus }"
>
  <ng-container
    *ngIf="tab.content"
    [ngTemplateOutlet]="tab.content"
  ></ng-container>
</div>
